import script from "./EquipmentAddPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipmentAddPage.vue?vue&type=script&setup=true&lang=js"

import "./EquipmentAddPage.vue?vue&type=style&index=0&id=0507f696&scoped=true&lang=css"

import exportComponent from "F:\\MyCode\\ZSTek.SpecialEquipment\\ZSTek.SE.Screen.Web.Backstage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0507f696"]])

export default __exports__